import axios from 'axios'

export default {
    namespaced: true,
    state: {
        tasks: [],
        activeShift: 0
    },
    mutations: {
        FETCH_TASKS(state, payload) {
            state.tasks = payload
        },
        NEW_TASK(state, payload) {
            state.tasks.push(payload)
        },
        EDIT_TASK(state, payload) {
            const index = state.tasks.findIndex(
                item => item.id === payload[0].id
            )

            if (index !== -1) {
                Object.assign(state.tasks[index], payload[0])
            }
        },
        DEL_TASK(state, id) {
            const index = state.tasks.findIndex(
                list => list.id === id
            )
            state.tasks.splice(index,1)
        },
        DETACH_MAID(state, payload) {
            const index = state.tasks.findIndex(
                item => item.id === payload.id
            )
            state.tasks.splice(index,1)
        },
        CHANGE_TASK_STATUS(state, payload) {
            const index = state.tasks.findIndex(
                item => item.id === payload.id
            )
            if (index !== -1) {
                state.tasks[index].status = payload.status
            }
        },
        START_SHIFT(state) {
            state.activeShift = 1;
        },
        SET_ACTIVE_SHIFT(state, shift) {
            state.activeShift = shift;
        },
        CLEAR_DATA(state, payload) {
            if (payload > 1) {
                state.hotelBuilds = []
            }
            state.hotelRooms = [],
                state.workTypes = []
        }
    },
    actions: {
        fetch({commit, dispatch, state}, filter) {
            return new Promise((resolve) => {
                if (state.tasks.length) {
                    resolve()
                } else {
                    axios.get(
                        '/api/mixins/task/list',
                        {params: filter}
                    ).then(({data}) => {
                        commit('FETCH_TASKS', data.data)
                        resolve()
                    }).catch(error => {
                        dispatch('checkUnauthenticated', error, {root: true})
                    })
                }
            })
        },
        addComment({commit, dispatch}, comment) {
            return new Promise((resolve) => {
                axios.post(
                    '/api/mixins/comments/add',
                    comment
                ).then(({data}) => {
                    commit('EDIT_TASK', data.data)
                    resolve()
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        },
        /**
         * Выбирает базовые чек-листы
         * @returns {Promise<Object>} promise с базовыми чек-листами
         */
        changeStatus({commit, dispatch}, payload) {
            return new Promise((resolve) => {
                axios.put(
                    '/api/mixins/task/change/' + payload.id,
                    payload
                ).then(({data}) => {
                    if (!data) {
                        const msg = 'Произошла ошибка. Попробуйте отправить данные еще раз'
                        dispatch('showSystemMessage', {text: msg}, {root: true})
                    }
                    resolve()
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        },
        startShift({ commit }) {
            return new Promise((resolve, reject) => {
                axios.post('/api/staff/time/add')
                    .then(() => {
                        commit('START_SHIFT');
                        resolve();
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        fetchActiveShift({ commit }) {
            return new Promise((resolve, reject) => {
                axios.get('/api/staff/time/fetch')
                    .then(({ data }) => {
                        commit('SET_ACTIVE_SHIFT', data.data.is_active);
                        resolve(data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        stopShift({ commit }) {
            return new Promise((resolve, reject) => {
                axios.put('/api/staff/time/stop')
                    .then(() => {
                        resolve();
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        clearData({commit}, quantity) {
            commit('CLEAR_DATA', quantity)
        }
    }
}
